<template>
  <div>
    <Card :title="title || '保单基本信息'">
      <Form :label-width="125" class="mt15">
        <Row>
          <Col span="12" v-if="type == 'policy'">
            <FormItem label="保单编号：">
              <span class="lineFeed">{{
                info.cntrNo ? info.cntrNo : info.guaranteeNo
              }}</span>
            </FormItem>
          </Col>
          <Col span="12" v-if="type == 'insurance'">
            <FormItem label="投保单编号：">
              <span class="lineFeed">{{ info.applicationNo }}</span>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="产品名称：">
              {{ info.productName }}
            </FormItem>
          </Col>
          <Col span="12" v-if="type == 'policy'">
            <FormItem label="保单创建时间：">
              {{ info.createTime }}
            </FormItem>
          </Col>
          <Col span="12" v-if="type == 'insurance'">
            <FormItem label="投保单创建时间：">
              {{ info.createTime }}
            </FormItem>
          </Col>
          <Col span="12" v-if="info.applicationStatus != 'QUOTING'">
            <FormItem label="保费（元）：">
              {{ info.premium }}
            </FormItem>
          </Col>
          <Col span="12" v-if="type == 'policy'">
            <FormItem label="保单状态：">
              {{ info.insurancePolicyStatusDesc }}
            </FormItem>
          </Col>
          <Col span="12" v-if="type == 'insurance'">
            <FormItem label="投保单状态：">
              {{ info.applicationStatusDesc }}
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="保险公司：">
              {{ info.companyName }}
            </FormItem>
          </Col>
          <template v-if="type == 'insurance'">
            <Col span="12">
              <FormItem label="保单编号：">
                <a
                  :href="'#/my/customizedCCIC/policyDetail/' + info.cntrNo"
                  target="_blank"
                  rel="opener"
                  class="lineFeed"
                  >{{ info.cntrNo }}</a
                >
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="订单编号：">
                <a
                  :href="'#/my/customizedCCIC/orderDetail/' + info.orderNo"
                  target="_blank"
                  rel="opener"
                  class="lineFeed"
                  >{{ info.orderNo }}</a
                >
              </FormItem>
            </Col>
          </template>
          <template v-if="type == 'policy'">
            <Col span="12">
              <FormItem label="投保公司：">
                {{ info.applicantName }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保单编号：">
                <a
                  :href="'#/my/customizedCCIC/insuranceDetail/' + info.applicationNo"
                  target="_blank"
                  rel="opener"
                  class="lineFeed"
                  >{{ info.applicationNo }}</a
                >
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="订单编号：">
                <a
                  :href="'#/my/customizedCCIC/orderDetail/' + info.orderNo"
                  target="_blank"
                  rel="opener"
                  class="lineFeed"
                  >{{ info.orderNo }}</a
                >
              </FormItem>
            </Col>
            <Col span="12" v-if="info.electronicPolicyUrl">
              <FormItem label="保单附件：">
                <a :href="info.electronicPolicyUrl" rel="opener" target="_blank" class="ml15"
                  >查看</a
                >
              </FormItem>
            </Col>
          </template>
          <Col span="12">
            <FormItem label="创建人账号：">
              {{ info.userPhone }}
            </FormItem>
          </Col>
          <Col span="12" v-if="info.fileList&&info.fileList.length>0">
            <FormItem label="投保单（盖章）：">
              {{ info.fileList[0].fileName }}
              <a :href="info.fileList[0].fileUrl" target="_blank" rel="opener" class="ml15">查看</a>
              <a @click="showImg" class="ml15">更多</a>
            </FormItem>
          </Col>
          <Col span="24" v-if="type=='insurance'&&info.remark">
            <FormItem label="备注：">
              {{ info.remark }}
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
    <Modal
        v-model="modal"
        title="历史投保单（盖章 ）"
		:mask-closable="false"
		width="60%">
          <Table border :columns="columns" :data="info.fileList">
              <template slot-scope="{ row }" slot="action">
				<a :href="row.fileUrl" rel="opener" target="_blank">查看</a>
              </template>
          </Table>
		  <div slot="footer">

		  </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    },
    title: String,
    type: {
      type: String,
      default() {
        return "policy";
      }
    }
  },
  data(){
    return {
      modal: false,
			columns:[
				{title:'操作时间',key:'createTime'},
				{title:'文件名',key:'fileName'},
				{title:'操作',slot: 'action'},
			]
    }
  },
  methods: {
    ok(){

    },
    cancel(){

    },
    showImg(){
			this.modal = true;
		}
    // renew () {
    // 	this.$router.push(`/installer/fillin-order/${this.$route.params.id}?hrCode=${this.info.hrCode}`)
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/common/PolicyBasicInfo.vue